<template>
  <el-dialog
    :modal-append-to-body="false"
    :visible.sync="visible"
    :title="$t('Integrations_Meta_Action_Reauthenticate')"
    width="400px"
    center
  >
    <el-row class="description" type="flex" justify="center">
      {{ $t('Integrations_Meta_Action_Reauthenticate_Desc') }}
    </el-row>
    <el-row type="flex" justify="center">
      <el-button type="primary" @click="reAuth">
        {{ $t('Integrations_Meta_Action_Reauthenticate') }}
      </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import Integrations from '@/modules/integrations/types'
export default {
  name: 'MetaReauthenticateDialog',

  data() {
    return {
      visible: false
    }
  },

  methods: {
    show() {
      this.visible = true
    },

    reAuth() {
      window.location.href = Integrations.meta.connectUrl(
        window.location.origin,
        this.$route.query.project_id,
        this.$route.query.id
      )
    }
  }
}
</script>

<style scoped>
.description {
  text-align: center;
  margin-bottom: 20px;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/meta/MetaReauthenticateDialog.vue